export const RecommendPlanEndpoints = {
  getRecommendPlanStatus: 'getRecommendPlanStatus',
  getPlanRecommendations: 'getPlanRecommendations',
  updateRecommendPlanStatus: 'updateRecommendPlanStatus',
} as const;
